import { render } from "./SocialstyrelsenGenericView.vue?vue&type=template&id=d90fd942"
import script from "./SocialstyrelsenGenericView.vue?vue&type=script&lang=js"
export * from "./SocialstyrelsenGenericView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__